export default {
  id: 'general-business',
  title: 'General Business Expenses',
  category: 'Employee',
  summary: 'Request approval for company (non-travel) purchases, then enter actual costs after purchase.',
  overview: 'General Business reports are purchase-request style. You typically need approval before buying, then you record actuals for reimbursement or company payment tracking.',
  howItWorks: [
    'Draft a request with line items describing what you need and estimated costs.',
    'Submit for approval — reviewers confirm the purchase is authorized.',
    'After approval and purchase, enter actual amounts and supporting documents.',
    'Reviewers process the completed report for payment or closing.'
  ],
  actions: [
    {
      name: 'Add line item',
      description: 'Adds a requested purchase item with description and estimated amount.'
    },
    {
      name: 'Save draft',
      description: 'Keeps the request editable without sending it for review.'
    },
    {
      name: 'Submit for approval',
      description: 'Routes the purchase request to expense reviewers. Wait for approval before purchasing when required by policy.'
    },
    {
      name: 'Enter actuals',
      description: 'Records what was actually spent and attaches receipts after the purchase.'
    }
  ],
  tips: [
    'Do not purchase before approval if your company requires pre-authorization.',
    'Use Other Direct Costs instead when the spend is specifically for a customer project.'
  ],
  related: ['expenses', 'expense-wizard', 'other-direct-costs', 'expense-review']
};



// WEBPACK FOOTER //
// ./client/help/content/general-business.js